import React from 'react';
import { InlinePlayerWrapper as CompiledInlinePlayerWrapper } from './inlinePlayerWrapper-compiled';
import { InlinePlayerWrapper as EmotionInlinePlayerWrapper } from './inlinePlayerWrapper-emotion';
import { fg } from '@atlaskit/platform-feature-flags';
export var InlinePlayerWrapper = function InlinePlayerWrapper(props) {
  return fg('platform_media_compiled') ? /*#__PURE__*/React.createElement(CompiledInlinePlayerWrapper, props) : /*#__PURE__*/React.createElement(EmotionInlinePlayerWrapper, props);
};